import { render } from "./index.vue?vue&type=template&id=0f7204ed"
import script from "./testimonials.js?vue&type=script&lang=js&external"
export * from "./testimonials.js?vue&type=script&lang=js&external"

import "./testimonials.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__